<div class="product-list">
  @for (product of products; track product) {
    <div class="product" (click)="onProductClick(product)">
      <button nz-button nzType="text" class="like-button" (click)="onToggleFavorite(product, $event)">
        @if (!product.is_favorite) {
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M13.3197 4.57717L12.499 5.39968L11.6757 4.57643C9.57663 2.47736 6.17336 2.47736 4.0743 4.57643C1.97523 6.67549 1.97523 10.0787 4.0743 12.1778L11.9697 20.0731C12.2626 20.366 12.7375 20.366 13.0304 20.0731L20.9318 12.1763C23.0262 10.0703 23.0298 6.67662 20.9304 4.57717C18.8275 2.47428 15.4226 2.47428 13.3197 4.57717ZM19.8682 11.1186L12.5 18.4822L5.13496 11.1171C3.62167 9.60385 3.62167 7.15037 5.13496 5.63709C6.64824 4.1238 9.10175 4.1238 10.6151 5.63709L11.9725 6.99453C12.2704 7.2924 12.7551 7.28659 13.0457 6.98168L14.3804 5.63783C15.8975 4.12073 18.3526 4.12073 19.8697 5.63783C21.3834 7.15148 21.3808 9.59775 19.8682 11.1186Z"
                fill="#AFB2B6"
              />
            </svg>
          </i>
        }
        @if (!!product.is_favorite) {
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
              <path
                d="M11.3197 1.57717L10.499 2.39968L9.67565 1.57643C7.57663 -0.522643 4.17336 -0.522643 2.0743 1.57643C-0.0247675 3.67549 -0.0247675 7.07875 2.0743 9.17785L9.96965 17.0731C10.2626 17.366 10.7375 17.366 11.0304 17.0731L18.9318 9.17635C21.0262 7.07035 21.0298 3.67662 18.9304 1.57717C16.8275 -0.525723 13.4226 -0.525723 11.3197 1.57717Z"
                fill="#CB2222"
              />
            </svg>
          </i>
        }
      </button>
      <div class="image">
        <img [src]="product.image" [alt]="product.name" />
      </div>
      <div class="info">
        <span class="paragraph-medium font-medium name">
          {{ translateService?.currentLang === 'en' ? product?.name : product?.name_es }}
        </span>
        <div class="categories">
          @for (category of product.categories; track category) {
            <div class="categories-item">
              <span class="text-[13px] md:text-[15px]">{{ category?.localizable_name | translate }}</span>
            </div>
          }
        </div>
      </div>
      <div class="price">
        @if (!!+product.price) {
          <span class="paragraph-medium bold">{{ +product.price | ceil }}</span>
          <span class="paragraph-medium regular font-medium text-gray-600">{{ 'rewards.ganas' | translate }}</span>
        }
        @if (!+product.price) {
          <div class="custom">
            <span class="paragraph-medium bold">{{ 'rewards.customAmout' | translate }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
